'use strict';

var _ = require('lodash');
var ChartSponsorForecastLegDataProviderService = function ChartSponsorForecastLegDataProviderService($filter, dataRetrieverService, constants, momentService) {
  var rmMomentFormat = $filter('rmMomentFormat');
  var MAPPING = {
    'Bookings': {
      'm1': 'resHoldTotal'
    },
    'Revenue': {
      'm1': 'currentRevenue'
    },
    'Load Factor': {
      'm1': 'currentLoadFactor'
    },
    'Capacity': {
      'm1': 'physicalCapacity'
    }
  };
  function retrieveData(market, departureDateFrom, departureDateTo) {
    var rqlQuery = '((legs.origin=="' + market.origin + '";' + 'legs.destination=="' + market.destination + '");' + '(legs.departureDate=ge="' + departureDateFrom.toISOString() + '";' + 'legs.departureDate=le="' + departureDateTo.toISOString() + '"))';
    return dataRetrieverService.getDataRetriever(constants.SCHEDULE_CHANGE_SCREEN, constants.SPONSOR_FORECAST_LEG_MODE).retrieveSimpleData(constants.SPONSOR_FORECAST_LEG_MODE, rqlQuery);
  }

  /**
   * SponsorLegTransformerFactory will be used to transform and limit the amount of data kept in cache.
   * @param selectedMetric
   * @param data that will be transformed
   * @returns {*}
   */
  function transformData(selectedMetric, data) {
    var metricMapping = MAPPING[selectedMetric];
    if (data === undefined) {
      return undefined;
    }
    return data.map(function (d) {
      var obj = Object.create(null);
      obj.m1 = d[metricMapping.m1];
      obj.d1 = d.departureDate;
      obj.stackLabel = rmMomentFormat(d.departureDate, 'DATE_ISO');
      return obj;
    });
  }
  function getData(market, selectedMetric) {
    var departureDateFrom = momentService.now(momentService.FIELD.DEPARTURE_DATE).subtract(1, 'years');
    var departureDateTo = momentService.now(momentService.FIELD.DEPARTURE_DATE);
    return retrieveData(market, departureDateFrom, departureDateTo).then(_.wrap(selectedMetric, transformData));
  }
  return {
    getData: getData
  };
};
ChartSponsorForecastLegDataProviderService.$inject = ['$filter', 'DataRetrieverService', 'DataRetrieverConstantsService', 'MomentService'];
module.exports = ChartSponsorForecastLegDataProviderService;